var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":"Help"}}),_c('hr'),_c('content-block',{attrs:{"slug":"client-help"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }